module.exports = __webpack_public_path__ + "img/cuipijiang.ac836d4b.jpg";